import React, { useState } from "react";
import HandleInputChange from "../../../utils/HandleInputChange";
import InputField from "../../../components/InputField";
import SelectField from "../../../components/SelectField";
import CreateUserAPI from "../api/CreateUserAPI";

// Create User Form
const CreateUserForm = ({ regions, setAlert }) => {
  const [formData, setFormData] = useState({
    username: "",
    name: "",
    password: "",
    region: "1",
    address: "",
    phoneNumber: "",
    privilege: "2",
  });

  // handler create new user
  const CreateUserHandler = async (e) => {
    e.preventDefault();
    const status = await CreateUserAPI({
      ...formData,
      notification: null,
      status: "1",
    });

    if (status === 201) {
      // Show alert and rest Data Item
      setAlert("created");
      setFormData({
        username: "",
        name: "",
        password: "",
        region: "1",
        address: "",
        phoneNumber: "",
        privilege: "2",
      });
    } else {
      setAlert("error");
    }

    setTimeout(() => {
      setAlert("null");
    }, 5000);
  };

  return (
    <form method="POST" className="w-full" onSubmit={CreateUserHandler}>
      <InputField
        name="name"
        label="الاسم"
        value={formData.name}
        onChange={(e) => HandleInputChange(e, setFormData)}
      />
      <InputField
        name="username"
        label="إسم المستخدم (يستخدم بتسجيل الدخول)"
        value={formData.username}
        onChange={(e) => HandleInputChange(e, setFormData)}
      />
      <InputField
        name="password"
        label="كلمة المرور"
        value={formData.password}
        onChange={(e) => HandleInputChange(e, setFormData)}
        type="password"
      />
      <InputField
        name="phoneNumber"
        label="رقم الهاتف"
        value={formData.phoneNumber}
        onChange={(e) => HandleInputChange(e, setFormData)}
      />
      <SelectField
        name="region"
        label="المنطقة"
        value={formData.region}
        onChange={(e) => HandleInputChange(e, setFormData)}
        options={regions}
      />
      <InputField
        name="address"
        label="العنوان"
        value={formData.address}
        onChange={(e) => HandleInputChange(e, setFormData)}
      />

      <SelectField
        name="privilege"
        label="نوع المستخدم"
        value={formData.privilege}
        onChange={(e) => HandleInputChange(e, formData)}
        options={[
          { id: "2", name: "موظف" },
          { id: "3", name: "عميل" },
        ]}
      />
      <button
        type="submit"
        className="rounded border-0 bg-indigo-500 px-6 py-2 text-lg text-white hover:bg-indigo-600 focus:outline-none"
      >
        تسجيل المستخدم
      </button>
    </form>
  );
};

export default CreateUserForm;
